import type {
    FutureStockQuantities,
    ProductOrderRestriction,
    StockQuantity,
} from '../types';
import { availabilityOrder } from '../types';
import getStockStatus from './getStockStatus';

const sortByAvailability = (a: string, b: string) => {
    return availabilityOrder.indexOf(a) - availabilityOrder.indexOf(b);
};

const getMinimumStockStatus = ({
    store,
    stock,
    futureStock,
    restriction,
    currentStockOnly = false,
}: {
    store: string;
    stock: StockQuantity[];
    futureStock: FutureStockQuantities[];
    restriction: ProductOrderRestriction[];
    currentStockOnly?: boolean;
}) => {
    const statuses = Array.from(
        new Set(
            stock.flatMap(stockItem =>
                getStockStatus({
                    store,
                    stock: stockItem,
                    futureStock: futureStock.find(
                        item => item.sku === stockItem.sku
                    ),
                    restriction: restriction.find(
                        item => item.sku === stockItem.sku
                    ),
                    currentStockOnly,
                }).map(({ status }) => status)
            )
        )
    ).sort(sortByAvailability);

    return statuses[0];
};

export default getMinimumStockStatus;
